export const acceptedFormContentsEn = {
  header: 'Invitation Accepted',
  headerDescription: `You'll now be able to see shared air quality trends in your Awair app.`,
  contactUsDescription: 'If you have any questions, please reach out to us at',
}

export const acceptedFormContentsKr = {
  header: '초대를 수락하였습니다',
  headerDescription: '어웨어 앱에서 해당 공기데이터를 확인해보세요.',
  contactUsDescription: '어웨어 제품/이용 문의는 이메일로 연락주세요. ',
}